module.exports = __webpack_public_path__ + "img/logo-icon.f1c60317.png";